module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-SemiboldItalic-b40dbbfcb06296186491ccaffbe4d11e.woff";